import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TileType } from '../../base/package/api/package/gaming/gaming-domain';
import style from './ui-placeholder.css?inline';

const CName = 'ui-placeholder';

@customElement(CName)
export class UIPlaceholder extends LitElement {
  static readonly styles = unsafeCSS(style);
  @property({ type: String }) type = TileType.P1;

  render() {
    return html`
      <div class="tiletype-${this.type.toLowerCase()}">&nbsp;</div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIPlaceholder;
  }
}
